module.exports = __webpack_public_path__ + "img/call-now-update.21c8e4f8.svg";